// extracted by mini-css-extract-plugin
export default {"box":"app-main_box__t8Wt+","social":"app-main_social__o0pYT"};